import { createSlice } from "@reduxjs/toolkit";
import {
  fetchInstitutions,
  saveInstitution,
  updateInstitution,
  fetchSingleInstitution,
  fetchCountries,
  fetchCurrencies,
  fetchIndustries,
  fetchDays,   
  // fetchConversionRate,
  fetchSubscriptionModels,
} from "./AdminDashboardThunk";

const initialState = {
  list: [],
  current: null,
  loading: false,
  saving: false,
  error: null,
  filters: {
    fromDate: null,
    toDate: null,
  },
  countries: [],
  currencies: [],
  industries: [],
  subscriptionModels: [],
  days: [],     
  // conversion: null,
};

const adminDashboardSlice = createSlice({
  name: "adminDashboard",
  initialState,
  reducers: {
    clearCurrent: (state) => {
      state.current = null;
    },
    setFilters: (state, action) => {
    state.filters = { ...state.filters, ...action.payload };
  },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchInstitutions.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchInstitutions.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;
      })
      .addCase(fetchInstitutions.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchSingleInstitution.fulfilled, (state, action) => {
        state.current = action.payload;
      })
      .addCase(fetchCountries.fulfilled, (state, action) => {
        state.countries = action.payload;
      })
      .addCase(fetchSubscriptionModels.fulfilled, (state, action) => {
        state.subscriptionModels = action.payload;
      })
      .addCase(fetchCurrencies.fulfilled, (state, action) => {
        state.currencies = action.payload;
      })
      .addCase(fetchIndustries.fulfilled, (state, action) => {
        state.industries = action.payload;
      })
      // ✅ NEW
      .addCase(fetchDays.fulfilled, (state, action) => {
        state.days = action.payload;
      })
      // .addCase(fetchConversionRate.fulfilled, (state, action) => {
      //   state.conversion = action.payload;
      // })
      .addCase(saveInstitution.pending, (state) => {
        state.saving = true;
      })
      .addCase(saveInstitution.fulfilled, (state) => {
        state.saving = false;
      })
      .addCase(updateInstitution.pending, (state) => {
        state.saving = true;
      })
      .addCase(updateInstitution.fulfilled, (state) => {
        state.saving = false;
      })
      .addCase(saveInstitution.rejected, (state, action) => {
        state.saving = false;
        state.error = action.payload;
      })
      .addCase(updateInstitution.rejected, (state, action) => {
        state.saving = false;
        state.error = action.payload;
      });

  },
});

export const { clearCurrent, setFilters  } = adminDashboardSlice.actions;
export default adminDashboardSlice.reducer;
